<template>
  <div>
    <woot-modal-header
      :header-title="schoolClassSection ? $t('SCHOOL_CLASS_SECTION.EDIT_MODAL_TITLE') : $t('SCHOOL_CLASS_SECTION.ADD_MODAL_TITLE')" />
    <div class="flex flex-col modal-content h-5/6">
      <div>
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_ACCOUNT_SELECT.LABEL') }}
        </label>
        <multiselect v-model="selectedSchoolAccount" track-by="id" label="school_name" :disabled="!!schoolAccount"
          :placeholder="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.PLACEHOLDER')" selected-label
          :select-label="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.SELECT_PLACEHOLDER')"
          :deselect-label="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.REMOVE')" :max-height="160"
          :options="schoolAccounts" :allow-empty="false" :option-height="104" :preselect-first="true" />
      </div>
      <div>
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_CLASS_SELECT.LABEL') }}
        </label>
        <multiselect v-model="selectedSchoolClass"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_CLASS_SELECT.PLACEHOLDER')" selected-label
          :select-label="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_CLASS_SELECT.SELECT_PLACEHOLDER')"
          :deselect-label="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_CLASS_SELECT.REMOVE')" :max-height="160" track-by="id"
          label="classLabel" :options="schoolClasses" :allow-empty="false" :option-height="104" :preselect-first="true"
          :disabled="!selectedSchoolAccount || !!schoolClass" />
      </div>

      <div>
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_SECTION_SELECT.LABEL') }}
        </label>
        <multiselect v-model="section" :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_SECTION_SELECT.PLACEHOLDER')"
          selected-label :select-label="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_SECTION_SELECT.SELECT_PLACEHOLDER')"
          :deselect-label="$t('SCHOOL_CLASS_SECTION.FORM.SCHOOL_SECTION_SELECT.REMOVE')" :max-height="160" track-by="id"
          label="class" :options="keducoreSchoolSections" :allow-empty="false" :option-height="104"
          :preselect-first="true" :disabled="!selectedSchoolClass" @open="findSchoolClassOptions" />
      </div>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.TOTAL_TUITION.LABEL') }}
        <input v-model.trim="enrollmentTotalTuition" type="text"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.TOTAL_TUITION.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENT_NUMBER.LABEL') }}
        <input v-model.trim="enrollmentInstallmentNumber" type="number"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENT_NUMBER.PLACEHOLDER')" min="1" />
      </label>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.TUITION.LABEL') }}
        <input v-model.trim="enrollmentTuition" type="text" disabled
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.TUITION.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <div>
        <input v-model.trim="enrollmentTotalDiscountIsPercentage" type="checkbox"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT_IS_PERCENTAGE.PLACEHOLDER')">
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT_IS_PERCENTAGE.LABEL') }}
        </label>
      </div>

      
      <label v-if="enrollmentTotalDiscountIsPercentage">
        {{ $t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT.LABEL') }}
        <input v-model.trim="enrollmentTotalDiscountPercentage" type="number"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT.PLACEHOLDER')" />
      </label>

      <label v-else>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT.LABEL') }}
        <input v-model.trim="enrollmentTotalDiscountValue" type="text"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.TOTAL_DISCOUNT.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.DISCOUNT.LABEL') }}
        <input v-model.trim="enrollmentDiscount" type="text" disabled
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.DISCOUNT.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.ANNUITY.LABEL') }}
        <input v-model.trim="contractAnnuity" type="text"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.ANNUITY.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <div>
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENTS_QUANTITY.LABEL') }}
        </label>
        <multiselect v-model="contractInstallmentQuantity"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENTS_QUANTITY.PLACEHOLDER')" selected-label
          :select-label="$t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENTS_QUANTITY.SELECT_PLACEHOLDER')"
          :deselect-label="$t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENTS_QUANTITY.REMOVE')" :max-height="160"
          :options="installmentsNumbersList" :allow-empty="true" :option-height="104" />
      </div>

      <label>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENT_VALUE.LABEL') }}
        <input v-model.trim="contractInstallmentValue" type="text" disabled
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.INSTALLMENT_VALUE.PLACEHOLDER')" v-mask="moneyMask" />
      </label>

      <div>
        <input v-model.trim="contractPunctualityDiscountIsPercentage" type="checkbox"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT_IS_PERCENTAGE.PLACEHOLDER')">
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT_IS_PERCENTAGE.LABEL') }}
        </label>
      </div>

      <label v-if="contractPunctualityDiscountIsPercentage">
        {{ $t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT.LABEL') }}
        <input v-model.trim="contractPunctualityDiscountPercentage" type="number"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT.PLACEHOLDER')" />
      </label>

      <label v-else>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT.LABEL') }}
        <input v-model.trim="contractPunctualityDiscountValue" type="text"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.PUNCTUALITY_DISCOUNT.PLACEHOLDER')"
            v-mask="moneyMask" />
      </label>

      <div>
        <input v-model.trim="contractWithdrawalFeeIsPercentage" type="checkbox"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE_IS_PERCENTAGE.PLACEHOLDER')">
        <label>
          {{ $t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE_IS_PERCENTAGE.LABEL') }}
        </label>
      </div>

      <label v-if="contractWithdrawalFeeIsPercentage">
        {{ $t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE.LABEL') }}
        <input v-model.trim="contractWithdrawalFeePercentage" type="number"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE.PLACEHOLDER')"/>
      </label>
      <label v-else>
        {{ $t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE.LABEL') }}
        <input v-model.trim="contractWithdrawalFeeValue" type="text"
          :placeholder="$t('SCHOOL_CLASS_SECTION.FORM.WITHDRAWAL_FEE.PLACEHOLDER')"
          v-mask="moneyMask" />
      </label>

      <div class="w-full">
        <woot-button @click.prevent="preparePayloadToSubmit">
          {{ $t('SCHOOL_CLASS_SECTION.FORM.SUBMIT') }}
        </woot-button>
        <woot-button class="button clear" @click.prevent="onClose">
          {{ $t('SCHOOL_CLASS_SECTION.FORM.CANCEL') }}
        </woot-button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import maskMixin from 'shared/mixins/inputMaskMixin';
import AccountsApi from 'dashboard/api/account.js';

export default {
  mixins: [alertMixin, maskMixin],
  props: {
    onClose: {
      type: Function,
      default: () => { },
    },
    onSubmit: {
      type: Function,
      default: () => { },
    },
    schoolAccount: {
      type: Object,
      default: () => { },
    },
    schoolClass: {
      type: Object,
      default: () => { },
    },
    schoolClassSection: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      show: true,
      selectedSchoolAccount: null,
      selectedSchoolClass: null,
      keducoreSchoolSections: [],
      id: null,

      section: '',
      enrollmentTotalTuition: '',
      enrollmentInstallmentNumber: '',
      enrollmentTuition: '',
      enrollmentDiscount: '',

      enrollmentTotalDiscountValue: '',
      enrollmentTotalDiscountPercentage: '',
      enrollmentTotalDiscountIsPercentage: '',

      contractAnnuity: '',
      contractInstallmentQuantity: '',
      contractInstallmentValue: '',

      contractPunctualityDiscountPercentage: '',
      contractPunctualityDiscountValue: '',
      contractPunctualityDiscountIsPercentage: '',
      
      contractWithdrawalFeePercentage: '',
      contractWithdrawalFeeValue: '',
      contractWithdrawalFeeIsPercentage: '',
    };
  },
  mounted() {
    this.selectedSchoolAccount = this.schoolAccount;
    this.selectedSchoolClass = this.schoolClasses.find(schoolClass => schoolClass.id === this.schoolClass?.id);

    this.id = this.schoolClassSection?.id;
    this.enrollmentTotalTuition = parseFloat(this.schoolClassSection?.enrollment_total_tuition).toFixed(2);
    this.enrollmentInstallmentNumber = this.schoolClassSection?.enrollment_installment_number;
    this.enrollmentTuition = parseFloat(this.schoolClassSection?.enrollment_tuition).toFixed(2);
    this.enrollmentTotalDiscountIsPercentage = this.schoolClassSection?.enrollment_total_discount_is_percentage;
    this.enrollmentDiscount = parseFloat(this.schoolClassSection?.enrollment_discount).toFixed(2);

    this.contractAnnuity = parseFloat(this.schoolClassSection?.contract_annuity).toFixed(2);
    this.contractInstallmentQuantity = this.schoolClassSection?.contract_installment_quantity;
    this.contractInstallmentValue = parseFloat(this.schoolClassSection?.contract_installment_value).toFixed(2);
    this.contractPunctualityDiscountIsPercentage = this.schoolClassSection?.contract_punctuality_discount_is_percentage;
    this.contractWithdrawalFeeIsPercentage = this.schoolClassSection?.contract_withdrawal_fee_is_percentage;

    this.schoolClassSection?.section && this.initializeSectionSelect(this.schoolClassSection?.section)

    this.contractWithdrawalFeePercentage = this.contractWithdrawalFeeIsPercentage && parseFloat(this.schoolClassSection?.contract_withdrawal_fee).toFixed(2);
    this.contractPunctualityDiscountPercentage = this.contractPunctualityDiscountIsPercentage && parseFloat(this.schoolClassSection?.contract_punctuality_discount).toFixed(2);
    this.enrollmentTotalDiscountPercentage = this.enrollmentTotalDiscountIsPercentage && parseFloat(this.schoolClassSection?.enrollment_total_discount).toFixed(2)
    
    this.contractWithdrawalFeeValue = !this.contractWithdrawalFeeIsPercentage && parseFloat(this.schoolClassSection?.contract_withdrawal_fee).toFixed(2);
    this.contractPunctualityDiscountValue = !this.contractPunctualityDiscountIsPercentage && parseFloat(this.schoolClassSection?.contract_punctuality_discount).toFixed(2);
    this.enrollmentTotalDiscountValue = !this.enrollmentTotalDiscountIsPercentage && parseFloat(this.schoolClassSection?.enrollment_total_discount).toFixed(2);
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
      accountId: 'getCurrentAccountId',
    }),
    schoolAccounts() {
      return this.getAccount(this.accountId)?.school_accounts || []
    },
    schoolClasses() {
      const classes = this.schoolAccounts.find(schoolAccount => schoolAccount.id === this.selectedSchoolAccount?.id)?.school_class_rules || []
      return classes.map(schoolClass => ({ ...schoolClass, classLabel: `${schoolClass.school_class} - ${schoolClass.schooling_type} - ${schoolClass.school_year}` }));
    },
    installmentsNumbersList() {
      return this.selectedSchoolAccount?.installments_quantity_options || [1,10,11,12,13];
    },
    getEnrollmentDiscount() {
      if (this.enrollmentTotalDiscountIsPercentage) {
        const tuition = this.moneyMaskToDecimal(`${this.enrollmentTuition}`)
        return (tuition * this.enrollmentTotalDiscountPercentage * 0.01).toFixed(2);
      } else {
        return `${this.roundMoneyToFloor(this.moneyMaskToDecimal(`${this.enrollmentTotalDiscountValue}`) / this.enrollmentInstallmentNumber)}`
      }
    }
  },

  watch: {
    enrollmentInstallmentNumber() {
      this.enrollmentTuition = `${this.roundMoneyToFloor(this.moneyMaskToDecimal(`${this.enrollmentTotalTuition}`) / this.enrollmentInstallmentNumber)}`;
      this.enrollmentDiscount = this.getEnrollmentDiscount;
    },
    enrollmentTotalTuition() {
      this.enrollmentTuition = `${this.roundMoneyToFloor(this.moneyMaskToDecimal(`${this.enrollmentTotalTuition}`) / this.enrollmentInstallmentNumber)}`;
      this.enrollmentDiscount = this.getEnrollmentDiscount;
    },
    enrollmentTotalDiscountValue(val) {
      const limitValue = (Math.floor(this.moneyMaskToDecimal(this.enrollmentTotalTuition) * 90) / 100).toFixed(2);
      const parsedVal = this.moneyMaskToDecimal(val);

      if ((parsedVal > limitValue) ||
        (this.enrollmentTotalDiscountValue == '')) {
        this.enrollmentTotalDiscountValue = limitValue;
      }

      this.enrollmentDiscount = this.getEnrollmentDiscount;
    },
    enrollmentTotalDiscountPercentage(val) {
      if ((val > 90)) {
        this.enrollmentTotalDiscountPercentage = 90;
      }

      this.enrollmentDiscount = this.getEnrollmentDiscount;
    },
    contractInstallmentQuantity() {
      this.contractInstallmentValue = `${this.roundMoneyToFloor(this.moneyMaskToDecimal(`${this.contractAnnuity}`) / this.contractInstallmentQuantity)}`;
    },
    contractAnnuity() {
      this.contractInstallmentValue = `${this.roundMoneyToFloor(this.moneyMaskToDecimal(`${this.contractAnnuity}`) / this.contractInstallmentQuantity)}`;
    },
  },

  methods: {
    payload() {
      return {
        id: this.id,
        section: this.section.class,
        enrollment_total_tuition: this.moneyMaskToDecimal(`${this.enrollmentTotalTuition}`),
        enrollment_installment_number: this.enrollmentInstallmentNumber,
        enrollment_tuition: this.moneyMaskToDecimal(`${this.enrollmentTuition}`),
        enrollment_total_discount: this.enrollmentTotalDiscountIsPercentage ? this.enrollmentTotalDiscountPercentage : this.moneyMaskToDecimal(`${this.enrollmentTotalDiscountValue}`),
        enrollment_total_discount_is_percentage: this.enrollmentTotalDiscountIsPercentage,
        enrollment_discount: this.moneyMaskToDecimal(`${this.enrollmentDiscount}`),
        contract_annuity: this.moneyMaskToDecimal(`${this.contractAnnuity}`),
        contract_installment_quantity: this.contractInstallmentQuantity,
        contract_installment_value: this.moneyMaskToDecimal(`${this.contractInstallmentValue}`),
        contract_punctuality_discount: this.contractPunctualityDiscountIsPercentage ? this.contractPunctualityDiscountPercentage : this.moneyMaskToDecimal(`${this.contractPunctualityDiscountValue}`),
        contract_punctuality_discount_is_percentage: this.contractPunctualityDiscountIsPercentage,
        contract_withdrawal_fee: this.contractWithdrawalFeeIsPercentage ? this.contractWithdrawalFeePercentage : this.moneyMaskToDecimal(`${this.contractWithdrawalFeeValue}`),
        contract_withdrawal_fee_is_percentage: this.contractWithdrawalFeeIsPercentage,
      }
    },

    preparePayloadToSubmit() {
      this.onSubmit(this.selectedSchoolAccount, this.selectedSchoolClass, this.payload());
      this.onClose();
    },

    roundMoneyToFloor(value) {
      return (Math.floor(value * 100) / 100).toFixed(2);
    },

    async findSchoolClassOptions() {
      try {
        if (this.selectedSchoolAccount.school_document && this.selectedSchoolClass.schooling_type && this.selectedSchoolClass.school_year) {
          const response = await AccountsApi.searchForClasses(this.selectedSchoolAccount.school_document, this.selectedSchoolClass.schooling_type,
            this.selectedSchoolClass.school_year);

          const combinedSections = response.data.classes.flatMap((schoolClass, index) =>
            schoolClass.academicClasses.map(academicClass => ({
              ...academicClass,
              schoolClass: schoolClass,
            }))
          );
          this.keducoreSchoolSections = combinedSections;
        }
      } catch (error) {
        this.showAlert($t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.API.ERROR'));
      }
    },

    async initializeSectionSelect(section) {
      await this.findSchoolClassOptions();
      this.section = this.keducoreSchoolSections.find(schoolSection => schoolSection.class === section);
    }
  }
};
</script>
<style lang="scss" scoped></style>
